<template>
  <div class="deploy-filter border-bottom">
    <div class="container">
      <div class="deploy-picker" v-if="recentActivity">
        <b-dropdown hoverable data-v-demo-deploys="0">
            <button class="button picker-button" slot="trigger">
                <span>{{ selectDeployText }} </span>
                <b-icon icon="menu-down"></b-icon>
            </button>

            <div v-for="(deploy, index) of pastDeploys" :key="index">
              <b-dropdown-item v-bind:class="{'is-active': index === selection}">
                <router-link class="deploy-link" :to="{name: 'CompareDeploys', query: {selection: index, projectID: projectID, deployID: deploy.id}}">
                  {{ deploy.commit.sha1.substring(0, 8) }} - {{ formatDate(deploy.time) }}
                </router-link>
              </b-dropdown-item>
            </div>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { gql } from "apollo-boost";

var moment = require("moment");

export default {
  name: "DeployFilter",
  apollo: {
    recentActivity: {
      query: gql`
        query recentActivity($id: Int) {
          recentActivity(projectID: $id, since: "2018-02-15T00:00:00Z") {
            ... on Deploy {
              id
              time
              commit {
                sha1
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.projectID
        };
      }
    }
  },
  props: {
    selection: {
      type: Number,
      default: -1
    },
    projectID: {
      type: Number,
      required: true
    },
    maxDeploys: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      recentActivity: null
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MM/DD/YYYY HH:MM");
    }
  },
  computed: {
    pastDeploys() {
      var deploys = this.recentActivity.filter(elem => {
        return elem.__typename === "Deploy";
      });

      // can't just check in the filter because the last element might not be a deploy
      let start = 0;
      let max = deploys.length - 1;
      if (max > this.maxDeploys) {
        start = max - this.maxDeploys;
      }

      return deploys.slice(start, max).reverse();
    },
    selectDeployText() {
      if (this.selection < 0 || this.pastDeploys.length <= 0) {
        return "Compare with deploy ";
      }

      return (
        "Selected: " +
        this.pastDeploys[this.selection].commit.sha1.substring(0, 8)
      );
    }
  }
};
</script>

<style>
.deploy-filter {
  width: 100%;
  height: 50px;
  background: white;
}

.deploy-picker {
  float: right;
  margin-top: 6px;
  padding-right: 40px;
}

.deploy-link {
  color: black;
}

.picker-button {
  background-color: #0091d5;
  color: white;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}
</style>
